// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9b3c62bc","453":"042f6385"}[chunkId] + ".chunk.js";
};